import gql from "graphql-tag";

export default gql`
  mutation AdminDeletePermitPortalUser($id: UUID!) {
    admin_deletePermitPortalUser(id: $id) {
      id
    }
  }
`;
